import {
  collection,
  doc,
  getDoc,
  updateDoc,
  getDocs,
  setDoc,
  where,
  query,
} from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Plan } from '../models/Plan';

export default function planService() {
  async function createPlan(plan: Plan): Promise<Plan> {
    try {
      // Add a new document with a generated id
      const planRef = doc(collection(db, 'plan'));
      plan.id = planRef.id;
      // later...
      await setDoc(planRef, plan);
      return plan;
    } catch (e) {
      console.error('Error adding document: ', e);
      return null;
    }
  }

  async function updatePlan(planId: string, Plan: Partial<Plan>): Promise<boolean> {
    try {
      console.log(planId, Plan);
      const planRef = doc(db, 'plan', planId);
      await updateDoc(planRef, { ...Plan });
      console.log('plan updated ');
      return true;
    } catch (e) {
      console.error('Error updating document: ', e);
      return false;
    }
  }

  // TODO: use onSnapshot(collection(db, "plan", id) to update plan in context
  async function getPlan(id: string): Promise<Plan> {
    const planRef = doc(db, 'plan', id);
    const planSnap = await getDoc(planRef);
    if (planSnap.exists()) {
      console.log('Document data:', planSnap.data());
      return planSnap.data() as Plan;
    } else {
      // doc.data() will be undefined in this case
      console.log('No such document!');
      return null;
    }
  }

  async function getAllPlans(): Promise<Plan[]> {
    const planRef = collection(db, 'plan');
    const planSnap = await getDocs(planRef);
    const plans: Plan[] = [];
    if (planSnap) {
      planSnap.forEach((element) => {
        plans.push(element.data() as Plan);
      });
      return plans;
    } else {
      // doc.data() will be undefined in this case
      console.log('No such collection!');
      return null;
    }
  }

  async function getPlansByUserId(userId: string): Promise<Plan[]> {
    // get plans where userId is equal to userId
    const planRef = collection(db, 'plan');
    const q = await query(planRef, where('userId', '==', userId));
    const plansSnap = await getDocs(q);
    const plans: Plan[] = [];
    if (plansSnap) {
      plansSnap.forEach((element) => {
        plans.push(element.data() as Plan);
      });
      return plans;
    } else {
      // doc.data() will be undefined in this case
      console.log('No such collection!');
      return null;
    }
  }

  return {
    createPlan,
    updatePlan,
    getPlan,
    getAllPlans,
    getPlansByUserId,
  };
}
